import { orderTotalDisplayStyles as styles } from "@insite/content-library/Components/OrderTotalDisplay";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css``,
};
